class WItextani extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.startAni();
    }

    // observer observe the view port and start animation 
    startAni() {
         let observer = new IntersectionObserver(
        function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
               if (entry.target.querySelector('.WI_aniH1') != null) {
                // in-view
                entry.target.querySelectorAll('.WI_aniH1 span').forEach((v)=>{
                    v.classList.add('in-viewHeading');
                });
               }
               if (entry.target.querySelector('.WI_aniH3') != null) {
                   entry.target.querySelector('.WI_aniH3')?.classList.add('txtSubHeadingFadeUp'); 
               }
               if (entry.target.querySelector('.WI_aniP') != null) {
                   entry.target.querySelector('.WI_aniP')?.classList.add('txtParaFadeUp'); 
               }
                if (entry.target.querySelector('.WI_aniBtn') != null) {
                   entry.target.querySelector('.WI_aniBtn')?.classList.add('txtButtonFadeUp'); 
               }
            }
        });
        },
        {
        rootMargin: "0px", // Load earlier (you can adjust this)
        }
    );
    observer.observe(this);
    }
}

customElements.define("wi-ani", WItextani);

